<template>
    <multiselect
        :options="options"
        :track-by="trackBy"
        @input="updateSelected"
        :value="value"
        v-model="inputVal"
        @close="close"
        :multiple="false"
        :show-labels="true"
        :close-on-select="closeOnSelect"
        :custom-label="customLabel"
        :placeholder="placeholder"
        :label="label"
        :select-label="selectLabel"
        :searchable="true"
        :internal-search="!isRemoteData"
        @search-change="search"
        :loading="loading"
        :show-no-options="showNoOptions"
        :show-no-results="showNoResults"
    >
        <template slot="afterList">
            <div v-observe-visibility="reachedEndOfList" v-if="hasNextPage"/>
        </template>
    </multiselect>
</template>


<script>
// Ispirazione da
// https://medium.com/@hugodesigns/how-to-use-the-most-complete-selecting-solution-for-vue-js-f991b2605364
// TODO: implementare visualizzazione errori di validazione
import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)

export default {
    name: "PSelect",

    components: {
        Multiselect,
    },

    props: {
        loading: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object
        },
        options: {
            type: Array
        },
        trackBy: {
            type: String
        },
        placeholder: {
            type: String
        },
        label: {
            type: String
        },
        customLabel: {
            type: Function
        },
        selectLabel: {
            type: String
        },
        fetchDataFunction: {
            type: Function
        },
        clearDataFunction: {
            type: Function
        },
        fetchDataOnCreated: {
            type: Boolean,
            default: false
        },
        closeOnSelect: {
            type: Boolean,
            default: false
        },
        onCloseSelect: {
            type: Function
        },
        showNoOptions: {
            type: Boolean,
            default: true
        },
        showNoResults: {
            type: Boolean,
            default: true
        },
        allowEmpty: {
            type: Boolean,
            default: false
        },
        nextPage: {
            type: Number
        }
    },

    data() {
        return {
            // optionsProxy: [],
            query: '',
            page: 1,
        }
    },

    created() {
        if (this.isRemoteData && this.fetchDataOnCreated)
            this.runFetchDataFunction()
        this.search = _.debounce((query) => {
            this.clearDataFunction()
            this.page = 1
            this.query = query
            this.runFetchDataFunction()
        }, 500)
    },

    computed: {
        isRemoteData() {
            return this.fetchDataFunction !== undefined
        },
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        hasNextPage() {
            return this.nextPage !== null
        }
    },

    methods: {
        close() {
            this.$emit('close-select')
        },

        updateSelected(value) {
            // v-model update
            this.$emit('input', value)
        },

        // runFetchDataFunction(query) {
        //     if (query.length < 3)
        //         return false
        //
        //     if (this.isRemoteData) {
        //         this.showLoadingSpinner = true
        //
        //         this.fetchDataFunction(query)
        //             .then(() => {
        //                 this.showLoadingSpinner = false
        //             })
        //     }
        // },

        runFetchDataFunction() {
            this.fetchDataFunction(this.page, this.query)
        },

        reachedEndOfList(reached) {
            if (reached) {
                this.page = this.nextPage !== null ? this.nextPage : 1
                this.runFetchDataFunction()
            }
        }
    },
}
</script>
